
import { useToast } from "@/components/ui/use-toast";
import { useTranslation } from "react-i18next";

/**
 * Hook for location tracking related notifications
 */
export const useLocationNotifications = () => {
  const { toast } = useToast();
  const { t } = useTranslation('common');

  const notifyTrackingStarted = () => {
    toast({
      title: t('ballDistance.tracking.startTracking'),
      description: t('ballDistance.tracking.startPosition'),
    });
  };

  const notifyDistanceCalculated = (distance: number) => {
    toast({
      title: t('ballDistance.tracking.finalDistance'),
      description: `${distance.toFixed(1)} ${t('ballDistance.dialogs.saveShot.meters')} ${t('ballDistance.tracking.traveled')}`,
    });
  };

  const notifyReset = () => {
    toast({
      title: t('ballDistance.tracking.reset'),
      description: t('ballDistance.tracking.resetConfirm'),
    });
  };

  const notifyError = (message: string) => {
    toast({
      title: t('toasts.errorSaving.title'),
      description: message,
      variant: "destructive",
    });
  };

  return {
    notifyTrackingStarted,
    notifyDistanceCalculated,
    notifyReset,
    notifyError
  };
};
